import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75M12 15v1.5m1.171-5.25H10.83a3 3 0 01-2.81-1.947L6.753 5.926a.5.5 0 01.469-.676h9.557a.5.5 0 01.468.676L15.98 9.303a3 3 0 01-2.809 1.947z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75M12 15v1.5m1.171-5.25H10.83a3 3 0 01-2.81-1.947L6.753 5.926a.5.5 0 01.469-.676h9.557a.5.5 0 01.468.676L15.98 9.303a3 3 0 01-2.809 1.947z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 26v13c0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5V21.5M24 30v3m2.342-10.5h-4.684a6 6 0 01-5.618-3.893l-2.533-6.756a1 1 0 01.936-1.351h19.114a1 1 0 01.936 1.351l-2.533 6.756a6 6 0 01-5.618 3.893z"
  }))
};
export var FlashlightOff = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});